import { useCallback } from 'react';
import { useParams } from 'react-router-dom';

import { storage, storageKeys, useStorage } from '@selfserve/react-hooks';

import { useGetLoginUrlRequest } from '../data';
import { KmeLoginPage } from '../ui/KmeLoginPage';

const defaultLoginUrl = process.env['NX_LOGIN_URL'];

interface IReturn {
  redirectToLoginPage: () => void;
  loginPage?: (trigger: boolean) => JSX.Element | null;
  status: number;
  requestType?: string
  isFetching?: boolean;
}

export const useGetLoginUrl = (passedId?: string): IReturn => {
  const { subscriptionId: subscriptionIdFromUrl } = useParams();
  const [loginUrl] = useStorage(storage.LOCAL, storageKeys.LOGIN_URL);
  const [subscriptionId] = useStorage(
    storage.SESSION,
    storageKeys.SUBSCRIPTION_ID
  );
  const { data: { data: responseData, status = 0 } = {}, isFetching } =
    useGetLoginUrlRequest(passedId || subscriptionId || subscriptionIdFromUrl);
  const { url, type: requestType, body } = responseData || {};

  const redirectToLoginPage = useCallback(() => {
    if (requestType !== 'POST') {
      window.location.href = (url || loginUrl || defaultLoginUrl) as string;
    }
  }, [url, loginUrl, requestType]);

  const loginPage = useCallback(
    (trigger: boolean) => {
      if (requestType === 'POST') {
        return (
          <KmeLoginPage
            url={url}
            requestType={requestType}
            body={body}
            triggered={trigger}
          />
        );
      }
      return null;
    },
    [url, requestType, body]
  );

  return { redirectToLoginPage, loginPage, status, requestType, isFetching };
};
